import React from 'react';
import { STATUS_META } from './paymentLinksStore';

export default function PaymentLinkStatusBadge({ status }) {
    const key = String(status || '').trim().toLowerCase();
    const meta = STATUS_META[key] || {
        label: status || 'Inconnu',
        className: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
    };

    return (
        <span
            className={`inline-flex items-center justify-center text-xs font-semibold rounded-full cydwr c1k3n ch4gv cdw1w ${meta.className}`}
        >
            {meta.label}
        </span>
    );
}
